import React, {useMemo} from 'react';
import { Box } from '@mui/joy';
import { KPI } from 'src/mtska-frontend-app-component';
import List from './List';

const Default = () => {

    return <>
        <Box className="mtska-chart-wrapper">
            <KPI
                title="Areas"
                icon="faGauge"
                dataProviderName={'statistics/item/count/commercials/area'}
            />
        </Box>
        <List />
    </>

}

export default Default;


